import { Box, Divider, Text } from '@citibox-panel/ui';
import type { UserSearchHit } from '@citibox-panel/api-client';
import { accountTypeLabel } from '../lib/accountType';

export interface AccountTypeRowProps {
  accountType: UserSearchHit['accountType'];
}

// The strip at the top of the ficha's data column that says what the opened account is. It renders
// nothing at all — not even its divider — when there is no label, so a missing role leaves the ficha
// exactly as it looked before rather than making a claim. It is a region of its own, padding and
// divider included, like the account and device regions below it, so the dividers keep running edge
// to edge of the column.
export function AccountTypeRow({ accountType }: AccountTypeRowProps) {
  const label = accountTypeLabel(accountType);
  if (label === null) return null;
  return (
    <>
      {/* Named for assistive tech, since on screen only its position says what the word is.
          TODO: i18n */}
      <Box role="group" aria-label="Tipo de cuenta" sx={{ px: 2, py: 0.75 }}>
        {/* muted and not secondary: this is the datum the agent acts on, and text.secondary fails
            AA contrast on white. No noWrap: a long role name wraps instead of hiding its end. */}
        <Text variant="overline" color="muted" bold dense>
          {label}
        </Text>
      </Box>
      <Divider />
    </>
  );
}
